/* ============================================================
   landing-hero
   video[data-bg-video]   muted loop video; source set and played while on
                          screen. [data-src-mobile] is used below 768px.
                          Never plays with reduced motion (poster only)
   form[data-klaviyo-form]     Klaviyo list embed form, submitted over AJAX.
                               On success the form hides and the sibling
     [data-klaviyo-intro]      takes the contents of the sibling
     template[data-klaviyo-success]
   ============================================================ */
(() => {
  const BREAKPOINTS = { mobile: 768 };
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideos() {
    if (prefersReducedMotion()) return;

    const observer = new IntersectionObserver((entries) => {
      for (const { target: video, isIntersecting } of entries) {
        if (!isIntersecting) {
          video.pause();
          continue;
        }
        if (!video.src) {
          const isMobile = window.innerWidth < BREAKPOINTS.mobile;
          video.src = (isMobile && video.dataset.srcMobile) || video.dataset.src;
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
        }
        video.play().catch(() => {});
      }
    });

    for (const video of document.querySelectorAll('video[data-bg-video]:not([data-bg-video-init])')) {
      video.setAttribute('data-bg-video-init', '');
      observer.observe(video);
    }
  }

  let klaviyoLoader;

  function loadKlaviyoSubscribe() {
    klaviyoLoader ??= new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
      script.onload = () => resolve(window.KlaviyoSubscribe);
      script.onerror = reject;
      document.head.append(script);
    });
    return klaviyoLoader;
  }

  /* Identifying the subscriber to klaviyo.js (Klaviyo app embed) links this browser
     to the profile, so Klaviyo sets location from IP the same way its own forms do. */
  function identifyKlaviyo(form) {
    const email = form.querySelector('[name="email"]')?.value.trim();
    if (!email || !window.klaviyo) return;
    const firstName = form.querySelector('[name="$first_name"]')?.value.trim();
    window.klaviyo.identify(firstName ? { email, first_name: firstName } : { email });
  }

  function showSuccess(form) {
    const intro = form.parentElement.querySelector('[data-klaviyo-intro]');
    const success = form.parentElement.querySelector('template[data-klaviyo-success]');
    form.hidden = true;
    if (!intro || !success) return;
    intro.replaceChildren(success.content.cloneNode(true));
    intro.classList.add('is-success');
  }

  function initKlaviyoForms() {
    const forms = document.querySelectorAll('form[data-klaviyo-form]:not([data-klaviyo-init])');
    if (!forms.length) return;
    for (const form of forms) form.setAttribute('data-klaviyo-init', '');

    loadKlaviyoSubscribe()
      .then((KlaviyoSubscribe) => {
        for (const form of forms) {
          KlaviyoSubscribe.attachToForms(`#${CSS.escape(form.id)}`, {
            hide_form_on_success: false,
            extra_properties: {
              $source: '$embed',
              $method_type: 'Landing Page Form',
              $method_id: 'embed',
            },
            success: () => {
              const error = form.querySelector('.error_message');
              if (error) error.style.display = 'none';
              showSuccess(form);
              identifyKlaviyo(form);
            },
          });
        }
      })
      .catch(() => {});
  }

  function init() {
    initVideos();
    initKlaviyoForms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
